import React, { useEffect, useState } from "react";
// Import the Provider from use-http and getAuth from firebase
import { Provider as FetchProvider } from 'use-http';
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { auth } from "./components/UserManagement/firebase";
import MainRouter from "./components/Base components/MainRouter";
import { Grommet } from "grommet";
import { deepFreeze } from "grommet/utils"
import { DataProvider } from './components/Contexts/DataContext';

// Create a context that will hold the entire user profile object.
// null is the initial value when the user is not logged in.
export const UserContext = React.createContext(null); 

function App(props) {
    // This state will now hold our custom user profile object.
    const [user, setUser] = useState(null);
    const [authChecked, setAuthChecked] = useState(false); // ensures auth is initialized before rendering

    console.log('REACT_APP_ENV in App.js:   ===>', process.env.REACT_APP_ENV);

    const customTheme = deepFreeze(
    {
        "global": {
            font: {
                family: "Segoe UI Semibold",
                size: "14px",
                //weight: "bold"
            },
        
            "global": {
                "colors": {
                    "brand": "#0096D6",
                    "control": {
                        "dark": "#00A8F0",
                        "light": "#0096D6"
                    },
                    "focus": "#99d5ef",
                    "accent-1": "#E6734B",
                    "accent-2": "#E6C84B",
                    "accent-3": "#915591",
                    "dark-1": "#000001",
                    "dark-2": "#676767",
                    "light-1": "#F2F2F2",
                    "light-2": "#E8E8E8",
                    "light-3": "#CCCCCC",
                    "neutral-1": "#006996",
                    "neutral-2": "#A65336",
                    "neutral-3": "#A69136",
                    "neutral-4": "#774677",
                    "status-critical": "#F04B37",
                    "status-warning": "#F0AA3C",
                    "status-ok": "#509137",
                    "status-unknown": "#848484",
                    "status-disabled": "#848484"
                }
            },
            "anchor": {
                "color": {
                    "dark": "#00A8F0",
                    "light": "#2883d7"
                }
            }
        },
        "eslintConfig": {
            "globals": {
              "window": true,
              "ActiveXObject": true
            }
        }, 
    }) 

    // Configure the use-http options with an interceptor
    const fetchOptions = {
        interceptors: {
            // This function runs before every single request is sent
            request: async ({ options }) => {
                const auth = getAuth();
                const currentUser = auth.currentUser;

                // If the user is logged in, get their token and add it to the header
                if (currentUser) {
                    try {
                        const token = await currentUser.getIdToken(true); // Force refresh token
                        options.headers.Authorization = `Bearer ${token}`;
                    } catch (error) {
                        console.error("Interceptor failed to get token:", error);
                    }
                }
                return options; // Return the modified options for the request
            },
        }
    };

    // 👇 Firebase auth state listener
    useEffect(() => {
        // onAuthStateChanged listens for user sign-in/sign-out events.
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // User is signed in. Now we get their ID token with all custom claims.
                const idTokenResult = await user.getIdTokenResult();

                // Create our own, complete user profile object.
                const profile = {
                    uid: user.uid,
                    email: user.email,
                    name: user.displayName || user.email.split('@')[0],
                    // Get the 'admin' claim. If it doesn't exist, isAdmin will be false.
                    isAdmin: idTokenResult.claims.admin === true, 
                };
                
                // Store the complete profile in our state.
                setUser(profile); // Сохраняем полный профиль в стейт

            } else {
                // User is signed out, clear the profile.
                setUser(null);
            }
            // Mark that the initial auth check is complete.
            setAuthChecked(true);
        });

        // Unsubscribe from the listener when the component unmounts.
        return () => unsubscribe();
    }, []);

    if (!authChecked) {
        return <div>Loading...</div>; // Render a loading screen during the check.
    }


    return (
        <React.StrictMode>
        <FetchProvider options={fetchOptions}>
            <DataProvider>
                {/* ✅ Provide the complete user profile to all child components. */}
                 <UserContext.Provider value={user}>                 
                    <Grommet theme={customTheme} full>
                        <MainRouter />
                    </Grommet>
                </UserContext.Provider>
            </DataProvider>
            </FetchProvider>
        </React.StrictMode>
      );
}

export default App;
